import {
  acceptanceStatusesBorderColorsMap,
  constructionBorderColorMap,
  internalAcceptanceBorderColorMap,
} from '../constants/stagesColorMaps';
import { getFlatsByGridData } from '../utils/getFlatsByGridData';

const STAGE_ENUM = {
  acceptance: 3,
  construction: 1,
  internalAcceptance: 2,
};

const acceptance = [
  [
    1,
    {
      value: 'Не принято',
      color: acceptanceStatusesBorderColorsMap.get(1),
      count: 0,
    },
  ],
  [
    2,
    {
      value: 'Принято с замечаниями',
      color: acceptanceStatusesBorderColorsMap.get(2),
      count: 0,
    },
  ],
  [
    3,
    {
      value: 'Принято',
      color: acceptanceStatusesBorderColorsMap.get(3),
      count: 0,
    },
  ],
  [
    4,
    {
      value: 'Односторонняя передача',
      color: acceptanceStatusesBorderColorsMap.get(4),
      count: 0,
    },
  ],
];

const construction = [
  [
    1,
    {
      value: 'Идут работы',
      color: constructionBorderColorMap.get(1),
      count: 0,
    },
  ],
  [
    2,
    {
      value: 'Работы завершены',
      color: constructionBorderColorMap.get(2),
      count: 0,
    },
  ],
];

const internalAcceptance = [
  [
    3,
    {
      value: 'Не готова к передаче',
      color: internalAcceptanceBorderColorMap.get(3),
      count: 0,
    },
  ],
  [
    4,
    {
      value: 'Готова к передаче',
      color: internalAcceptanceBorderColorMap.get(4),
      count: 0,
    },
  ],
];

const useFlatStagesCount = (gridData = [], stage) => {
  if (!gridData?.length) return [];

  const getInitialMap = (stage) => {
    switch (stage) {
      case STAGE_ENUM.construction:
        return new Map(construction);
      case STAGE_ENUM.acceptance:
        return new Map(acceptance);
      case STAGE_ENUM.internalAcceptance:
        return new Map(internalAcceptance);
      default:
        return new Map(acceptance);
    }
  };

  const countRequestMap = getInitialMap(stage);
  const flats = getFlatsByGridData(gridData);

  const incrementCount = (key) => {
    if (!key) return;
    const current = countRequestMap.get(key);
    if (current) {
      countRequestMap.set(key, {
        ...current,
        count: current.count + 1,
      });
    }
  };

  flats.forEach((flat) => {
    const lifeCycle = flat?.addressLifeCycle;
    if (!lifeCycle) return;

    const stageId = lifeCycle?.stageAddressLifeCycle?.id;
    const stepId = lifeCycle?.stepAddressLifeCycle?.id;
    const acceptanceId = lifeCycle?.acceptanceStatusAddressLifeCycle?.id;

    switch (stage) {
      case STAGE_ENUM.construction:
        if (stageId === STAGE_ENUM.construction) {
          incrementCount(stepId);
        }
        break;

      case STAGE_ENUM.internalAcceptance:
        if (
          stageId === STAGE_ENUM.internalAcceptance &&
          (stepId === 3 || stepId === 4)
        ) {
          incrementCount(stepId);
        }
        break;

      case STAGE_ENUM.acceptance:
        if (acceptanceId) {
          incrementCount(acceptanceId);
        }
        break;

      default:
        break;
    }
  });

  return Array.from(countRequestMap.values());
};

export default useFlatStagesCount;
